// Angular
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

// 3d party
import { TreeTableModule } from "primeng/treetable";
import { PrimeNgModule } from "@primeng";
import { ChartModule } from "primeng/chart";


// BBWT
import { GridModule } from "@features/grid";
import { BbwtSharedModule } from "@bbwt/bbwt-shared.module";
import { CssInjectionScopeDirective } from "@main/reporting.v3/core/rendering/css-injection-scope.directive";
import { HtmlRenderingService } from "@main/reporting.v3/core/rendering/html-rendering.service";
import { VariableRuleService } from "@main/reporting.v3/core/variables/variable-rule.service";
import { RegexUtilityService } from "@main/reporting.v3/core/regex/regex-utility.service";
import { WidgetSourceService } from "@main/reporting.v3/api/widget-source.service";
import { QuerySourceService } from "@main/reporting.v3/api/query-source.service";
import { VariablesService } from "@main/reporting.v3/api/variables.service";


@NgModule({
    declarations: [
        CssInjectionScopeDirective
    ],
    providers: [
        RegexUtilityService,
        HtmlRenderingService,
        VariableRuleService,
        WidgetSourceService,
        QuerySourceService,
        VariablesService
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PrimeNgModule,
        TreeTableModule,
        ChartModule,

        // BBWT
        GridModule,
        BbwtSharedModule
    ],
    exports: [
        CssInjectionScopeDirective
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ReportingCoreModule {
}